import { Brain, Users, ShieldCheck, Smartphone, Sparkles, Trophy } from "lucide-react";

export const SIBLING_DISCOUNT = 0.15;

export const JR_DECK_PHOTOS = [
  "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/qmcgb958_DSC_2699.jpg",
  "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/5hedikfg_DSC_2648.jpg",
  "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/9c2fw01q_DSC_2674.jpg",
  "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/r9ezf2ho_DSC_2727.jpg",
];

export const JR_PHOTOS = {
  decks: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/o4aghb0q_DSC_2699.jpg",
  setup: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/9c2fw01q_DSC_2674.jpg",
  lounge: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/irjscrt2_DSC_0145.jpg",
  gear: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/5hedikfg_DSC_2648.jpg",
  room: "https://customer-assets.emergentagent.com/job_dreammakers-studio/artifacts/r9ezf2ho_DSC_2727.jpg",
  group: "https://static.prod-images.emergentagent.com/jobs/11b5f9da-5695-4228-9b97-e837295ecfda/images/eb434bf58951eeecd9bc1b747e499d20caadf3c26c5d5d9523d3fd67f2fdc4d8.jpeg",
  coach: "https://static.prod-images.emergentagent.com/jobs/11b5f9da-5695-4228-9b97-e837295ecfda/images/b1b55bc4a02f72406660f07e574021d7a05047ee5c3fa0bfc6a177667f5438d0.jpeg",
  friends: "https://static.prod-images.emergentagent.com/jobs/11b5f9da-5695-4228-9b97-e837295ecfda/images/27f34f72e2577e27a808545d2f4b6a0154e5485f08212a8e385d79aa94223d57.jpeg",
};

export const JR_PACKAGES = [
  {
    id: "junior_dj_casual",
    name: "Casual Private Lesson",
    price: 150,
    duration: "1.5 hours",
    sessions: 1,
    tagline: "Try it out: one lesson, zero commitment",
    features: [
      "Personal one-on-one coaching",
      "Beatmatching, mixing & transitions",
      "Pioneer CDJ-3000s + DJM-A9",
      "Free water & soft drinks",
      "Parent lounge, coffee & TV",
    ],
    accent: "from-cyan-400 to-blue-500",
    ring: "border-cyan-400/40",
  },
  {
    id: "junior_dj_starter",
    name: "4-Week DJ Starter",
    price: 500,
    duration: "6 hours",
    sessions: 4,
    tagline: "Our best value: a full summer pathway",
    best: true,
    features: [
      "Four sessions booked in advance",
      "USB with your chosen music",
      "Music loaded before your lesson",
      "Personalised learning pathway",
      "Personal one-on-one coaching",
      "Beatmatching, mixing & transitions",
      "Pioneer CDJ-3000s + DJM-A9",
      "Free water & soft drinks",
      "Parent lounge, coffee & TV",
      "1 FREE hour of room hire",
      "Sibling? Save 15% on the second child",
    ],
    accent: "from-lime-300 via-yellow-300 to-pink-400",
    ring: "border-lime-300/60",
  },
];

export const JR_BENEFITS = [
  { icon: Brain, title: "A real outlet for mental health", text: "Music gives young people a positive way to express themselves, switch off and look after their headspace." },
  { icon: Users, title: "Make friends, build a network", text: "A social space where students meet others who love music and start building their creative circle." },
  { icon: ShieldCheck, title: "A SAFE new hobby", text: "No more sports injuries, no hard-working trainers yelling from the sideline. Just music, skill and fun." },
  { icon: Trophy, title: "Confidence & focus", text: "Learning to DJ builds concentration, timing and the confidence that comes from mastering a real skill." },
  { icon: Smartphone, title: "Less time alone on screens", text: "Long holiday days get structure, routine and something exciting to look forward to every week." },
  { icon: Sparkles, title: "Club-standard from day one", text: "Students learn on the same Pioneer CDJ-3000s and DJM-A9 used in the world's biggest clubs." },
];

export const JR_TRUST = [
  "All coaches hold a WWCC",
  "Police checks on every coach",
  "Safe, supervised & welcoming",
  "Parent lounge: coffee & TV",
];

export const JR_FAQ = [
  { q: "Does my child need any experience?", a: "Not at all. We teach complete beginners and help experienced students level up. Every session is built around the student." },
  { q: "Can teenagers book themselves?", a: "Students aged 15–17 can book their own lessons. We'll call a parent or guardian to confirm before the first session. Under 15s must be booked by a parent or guardian." },
  { q: "What happens after I book?", a: "We'll give you a quick call to chat about your child, collect their favourite songs and load them onto their USB before the first lesson." },
  { q: "Can parents stay during the lesson?", a: "Absolutely. Relax in our parent lounge with coffee and TV while your child learns next door." },
  { q: "When are lessons available?", a: "9AM–9PM, 7 days a week. The summer holiday program runs from 19 December 2026 to 24 January 2027, and lessons continue all year round after that." },
  { q: "Do you offer a sibling discount?", a: "Yes! Add a second child to the 4-Week DJ Starter in the same booking and save 15% on their package ($425 instead of $500). Each child picks their own 4 sessions." },
  { q: "Can I pay later?", a: "Yes. Afterpay and Zip Pay are available at checkout, e.g. the 4-Week Starter is $125 today with Afterpay." },
];
